<ng-template #staticPerformersAndSponsors>
  <static-performer-cards 
    *ngIf="!!performerIds?.length && performers" 
    [ngClass]="{brief: brief, full: !condensedPerformers, noHeading: hidePerformersHeading}" 
    [hidePerformersHeading]="hidePerformersHeading"
    [narrowPerformersHeading]="narrowPerformersHeading" 
    [performerIds]="performerIds" 
    [performerRoles]="performerRoles"
    [performerRoleIds]="performerRoleIds"
    [performers]="performers" 
    [condensedPerformers]="condensedPerformers" 
    [labelMap]="labelMaps?.performer_labels
  "></static-performer-cards>
  <static-sponsor-cards 
    *ngIf="sponsorIds?.length && sponsors" 
    [ngClass]="{brief: brief, full: !condensedPerformers}" 
    [sponsorIds]="sponsorIds" 
    [sponsors]="sponsors" 
    [sponsorTypes]="sponsorTypes" 
    [sponsorsCustomTitle]="sponsorsCustomTitle"
    [condensedSponsors]="condensedPerformers" 
    [hideNames]="true"
    [labelMap]="labelMaps?.sponsor_labels"
  ></static-sponsor-cards>
</ng-template>

<ng-template #publicLinksTemplate>
  <div class="public-links" *ngIf="publicLinks?.length">
    <button *ngFor="let link of publicLinks" mat-button color="primary" class="cta ellipsis" (click)="helpers.goToUrl($event, link.linkUrl)">{{ link.filename }}</button>
  </div>
</ng-template>

<div class="session" [ngClass]="{link: link}">

  <div class="check-holder" *ngIf="!!checking">
    <mat-checkbox color="primary" class="check" (change)="onCheck.emit()" [checked]="checked"></mat-checkbox>
  </div>

  <div class="time" [ngClass]="{ militaryTime: militaryTime }" *ngIf="!hideTimeLine && !timeAbove">
    <div class="start" *ngIf="start">{{ start | militaryTime:militaryTime }}</div>
    <div class="end" *ngIf="start">{{ end | militaryTime:militaryTime }}</div>
    <div class="end timezoneAbbr" *ngIf="timezoneAbbr && !hideTimeZone && start" >{{ timezoneAbbr }}</div>
  </div>
  <div class="line_dot" [ngClass]="{first:first, last:last}" *ngIf="!hideTimeLine">
    <div class="line top" [ngClass]="{ timeAbove: timeAbove }" ></div>
    <div class="dot" *ngIf="start || !hideDot"></div>
    <div class="line bottom"></div>
  </div>

  <div class="print_wrapper" [ngClass]="{ hideOverflow: !tagData }">
    <div class="print_only" *ngIf="start && printDate">
      <span class="full_time">{{start}} - {{end}}</span> ({{ duration }})<span class="date" *ngIf="printDate"> &bull; {{ (printDate | typeof) === 'string' ? printDate : (printDate | date:"EEEE d MMMM y") }}</span>
    </div>
    <div class="time-above" *ngIf="!hideTimeLine && timeAbove && start">
      <span style="font-weight: bold">{{ start }} - {{ end }}</span> ({{ duration }} mins)
    </div>
    <div class="info_container"
      [ngClass]="{break: isBreak, activity: type === 'activity', session: type === 'session', access: type === 'access', clear: type === 'clear', hoverable: !brief && link && !publicView, brief: brief}" 
      (click)="selectItem.emit()"
    >
      <div class="tab" [ngClass]="{ incomplete: activityIncomplete }"></div>
      <div class="session_container" onkeyup="toggleCollapseKeyPress($event)">
        <div class="title" [ngClass]="{brief: (brief || collapsible) && showExpand }" (click)="(!brief && !collapsible) || !showExpand ? null : toggleCollapse($event)">
          <div class="title-labels-holder">
            <div class="title-left">
              <icon *ngIf="activityComplete" icon="tick_12px"></icon><span [ngClass]="{gray: !title || activityComplete }">{{ title || (type === 'activity' ? 'Unnamed activity...' : isBreak ? 'Unitled break...' : 'Untitled session...') }}<span *ngIf="isBreak" class="break"> (Out-of-session)</span></span>
            </div>
            <div class="labels" *ngIf="!brief && labelMap && labelIds?.length" [ngClass]="{ collapsed: ( manualCollapse ? forcedCollapseState : collapseState ) === 'collapse' }">
              <ng-container *ngFor="let lbl of labelIds">
                <label-item *ngIf="labelMap[lbl]" [color]="labelMap[lbl].color" [label]="labelMap[lbl].label"></label-item>
              </ng-container>
            </div>
            <div *ngIf="epoch && userSelectedTimezone" class="user-selected-timezone">
              {{ epoch | userSelectedPublishTimezoneText: userSelectedTimezone }}
            </div>
          </div>
          <div style="flex:1;"></div>
          <tag-popup 
            *ngIf="tagData"
            [data]="tagData" 
            [showPopup]="!!popupDir"
            [photoSize]="multi ? 16 : 18"
            [width]="multi ? 280 : null"
            [topThreshold]="publicView ? .5 : .75"
            (onPopupTop)="popupDir = $event ? 1 : -1; "
            (hidePopup)="popupDir = 0"
            (click)="$event.stopPropagation(); !!popupDir ? popupDir = 0 : null;"
          ></tag-popup>
          <div class="title-right" *ngIf="(brief || collapsible) && showExpand">
            <expand-icon [expanded]="( manualCollapse ? forcedCollapseState : collapseState ) === 'expand'"></expand-icon>
          </div>
        </div>

        <div class="body-container" #bodyContainer [@drop]="(manualCollapse ? forcedCollapseState : collapseState )">
          <!-- "normal" timeline item body -->
          <ng-container *ngIf="!brief && !isBreak">
            <div class="description" *ngIf="!!description" [innerHTML]="helpers.strWithBreak(description)"></div>
            <ng-container [ngTemplateOutlet]="publicLinksTemplate"></ng-container>
            <ng-container [ngTemplateOutlet]="staticPerformersAndSponsors"></ng-container>
            <div class="program" [ngClass]="{link: link && !standalone}" *ngIf="programLine" (click)="clickProgram($event)">
              {{ programLine }}
            </div>
          </ng-container>

          <!-- "performer brief" timeline item body - nice job keeping it simple, guys -->
          <ng-container *ngIf="brief">
            <ng-container [ngTemplateOutlet]="publicLinksTemplate"></ng-container>
            <div class="item-section" *ngIf="!!description">
              <h5>{{ type === 'activity' ? 'ACTIVITY' : 'SESSION' }} DESCRIPTION</h5>
              <span [innerHTML]="helpers.strWithBreak(description)"></span>
            </div>
            <div class="item-section" *ngIf="labelMap && labelIds?.length">
              <h5>{{ type === 'activity' ? 'ACTIVITY' : 'SESSION' }} LABELS</h5>
              <div class="labels">
                <ng-container *ngFor="let lbl of labelIds">
                  <label-item *ngIf="labelMap[lbl]" [color]="labelMap[lbl].color" [label]="labelMap[lbl].label"></label-item>
                </ng-container>
              </div>
            </div>
            <div class="item-section" *ngIf="scheduleName">
              <h5>{{ type === 'activity' ? 'SCHEDULE' : 'PROGRAM' }}</h5>
              {{ scheduleName }}
            </div>
            <div class="item-section" *ngIf="fullLocation">
              <h5>LOCATION</h5>
              {{ fullLocation }}
            </div>
        
            <ng-container [ngTemplateOutlet]="staticPerformersAndSponsors"></ng-container>

            <ng-container *ngIf="{ 
              showPresentationAssets: type === 'session' && !!presentationAssets?.length, 
              showAssets: !!otherAssets?.length, 
              showNotes: type === 'session' && !!presentationNotes?.length, 
              showLogistics: !!files?.length || !!stagingNotes || !stagingRequests } as vars"
            >
              <div class="section expandables" *ngIf="vars.showAssets || vars.showNotes || vars.showLogistics">

                <expanding-wrapper
                  *ngIf="vars.showAssets"
                  [title]="'Assets'"
                  [borderDarkGreyOnCollapse]="true"
                >
                  <asset-link *ngFor="let asset of otherAssets; last as last"
                    (click)="$event.stopPropagation()"
                    [ngStyle]="{ marginBottom: last ? '0px' : '5px' }"
                    [asset]="asset"
                    [onlyLink]="true"
                  ></asset-link>
                </expanding-wrapper>

                <expanding-wrapper
                  *ngIf="vars.showNotes"
                  [title]="'Presentation Notes'"
                  [borderDarkGreyOnCollapse]="true"
                >
                  <expandable-info *ngFor="let note of presentationNotes" [lightOnCollapse]="true" [item]="note"></expandable-info>
                </expanding-wrapper>

                <expanding-wrapper
                  *ngIf="vars.showLogistics"
                  [title]="'Session Logistics'"
                  [borderDarkGreyOnCollapse]="true"
                >
                  <div class="item-section" *ngIf="stagingNotes">
                    <h5>STAGING NOTES</h5>
                    <div [innerHTML]="helpers.strWithBreak(stagingNotes)"></div>
                  </div>
                  <div class="item-section" *ngIf="files?.length">
                    <h5>FILES</h5>
                    <file-link *ngFor="let file of files" [file]="file" [onlyLink]="true"></file-link>
                  </div>
                  <div class="item-section" *ngIf="!!stagingRequests?.length">
                    <h5>STAGING REQUESTS</h5>
                    <staging-requests [stagingRequests]="stagingRequests"></staging-requests>

                  </div>
                </expanding-wrapper>  
              </div>
            </ng-container>          
          </ng-container>

        </div>
      </div>
    </div> <!-- *** info_container *** -->
    <ng-content select=".info-bottom"></ng-content>
  </div>
</div>